import * as api from '@utils/api'
import { RefundReasonType } from '@types'

export const getAdminRefundReasons = async (): Promise<RefundReasonType[]> => {
  const response = await api.GET('/p4/orders/refundReasons/admin')

  return response.data
}
